import checker from './checker'
import { operationsTypes } from 'pages/setStake/interfaces'
import { Notifications } from 'library/constants'

// Function for all mathematical operations in games, makes +, -, 1/2, 2x, 5x, checks valid stake and shows notifications.
// required props: stake, operation type, delta, toFix, max stake, min stake, notification handler
// optional : currency, if zero stake is enable - isZero
// return new stake

// CHECKINGS
// check for valid inputs
// check for max stake
// check for min stake

// function gets 6 parameters :

// current stake - string
// oparion name : plus | minus | 2x | 5x | 1/2 - strings
// delta - increment/decrement : string
// toFix - numbers after dot : number
// max - maximum stake limit : string
// min - minimum stake limit : string

// returns new stake - number. (toFix) numbers after dot.

export const mathOperations = (
  stake: string,
  operation: operationsTypes,
  precision: number,
  max: string,
  min: string,
  handleNotification?: any,
  currency?: string,
  isZero?: boolean,
): string => {
  const delta = (1 / Math.pow(10, precision)).toString()
  if (checker(stake, operation, delta)) return Number(delta).toFixed(precision)
  let newStake = +stake

  const minRange = +min + +delta
  switch (operation) {
    case 'plus':
      newStake += +delta
      break
    case 'minus':
      if (isZero) {
        newStake > +min && newStake < minRange
          ? (newStake = +min)
          : newStake < +min
          ? (newStake = 0)
          : (newStake -= +delta)
      } else {
        newStake -= +delta
      }
      break
    case '1/2':
      if (isZero) {
        // newStake > +min && newStake < minRange
        //   ? (newStake = +min)
        //   : newStake <= +min
        //   ? (newStake = 0)
        //   : (newStake /= 2)
        if (newStake > +min && newStake < minRange) {
          newStake = +min
        } else if (newStake <= +min || newStake / 2 < +min) {
          newStake = 0
        } else {
          newStake /= 2
        }
      } else {
        newStake /= 2
      }
      break
    case '2x':
      isZero && newStake === 0 ? (newStake = +min) : (newStake *= 2)
      break
    case '5x':
      isZero && newStake === 0 ? (newStake = +min) : (newStake *= 5)
      break
    case '10x':
      isZero && newStake === 0 ? (newStake = +min) : (newStake *= 10)
      break
    default:
      break
  }

  if (newStake > +max) {
    handleNotification(
      Notifications.maxStake + (+max).toFixed(precision) + ' ' + currency,
    )
    return (+max).toFixed(precision)
  }
  if (newStake < +min && !isZero) {
    handleNotification(
      Notifications.minStake + (+min).toFixed(precision) + ' ' + currency,
    )
    return (+min).toFixed(precision)
  }
  return newStake.toFixed(precision)
}
